import { Outlet } from "react-router-dom";
import Auth from "@pages/Auth/container";
import { AuthWrapper } from "../styled";

function AdminLayout() {
    return (
        <AuthWrapper>
            <Auth />
            <Outlet />
        </AuthWrapper>
    );
}

export default AdminLayout;
